import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-grupopessoa-grid', grid)
Vue.component('app-grupopessoa-edit', edit)
Vue.component('app-grupopessoa-select', select)
